import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type BurgerMenuView = 'menu' | 'release-notes';

interface ReleaseNoteState {
  isBurgerMenuOpen: boolean;
  burgerMenuView: BurgerMenuView;
  setIsBurgerMenuOpen: (isOpen: boolean) => void;
  setBurgerMenuView: (view: BurgerMenuView) => void;
  openReleaseNotes: () => void;
  isReleaseToastVisible: boolean;
  setReleaseToastVisible: (visible: boolean) => void;
  isAppLoading: boolean;
  setIsAppLoading: (isLoading: boolean) => void;
}

const useReleaseNoteStore = create<ReleaseNoteState>()(
  devtools(
    (set) => ({
      isBurgerMenuOpen: false,
      burgerMenuView: 'menu',

      setIsBurgerMenuOpen: (isOpen) =>
        set(
          (state) => ({
            isBurgerMenuOpen: isOpen,

            burgerMenuView: isOpen ? state.burgerMenuView : 'menu',
          }),
          false,
          'setIsBurgerMenuOpen'
        ),

      setBurgerMenuView: (view) => set({ burgerMenuView: view }, false, 'setBurgerMenuView'),

      openReleaseNotes: () =>
        set(
          {
            isBurgerMenuOpen: true,
            burgerMenuView: 'release-notes',
          },
          false,
          'openReleaseNotes'
        ),
      isReleaseToastVisible: false,
      setReleaseToastVisible: (visible: boolean) => set({ isReleaseToastVisible: visible }),
      isAppLoading: true,
      setIsAppLoading: (isLoading) => set({ isAppLoading: isLoading }),
    }),
    { name: 'ReleaseNoteStore' }
  )
);

export default useReleaseNoteStore;
